import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { SysFeatures } from "../../model/core/SysFeatures";
import { ColumnDefinition } from "../../model/ColumnDefinition";
import { IUserLookupService } from "../../lookup/model/IUserLookupService";
import { SystemConfigPromiseService } from "shared/auth-services";

// OMS-30890 Per Keith D, "-" is reserved for empty numerical fields.
import {
  EMPTY_AMT_RATE_VALUE,
  EMPTY_TEXT_VALUE,
} from "shared/cubiq-services/model/BaseTableDefinitionFactory";

export class UserNameHelper {
  private myUserLookup: IUserLookupService;
  private showUserName: boolean;

  constructor(userLookup: IUserLookupService, sysConfigService: SystemConfigPromiseService) {
    this.myUserLookup = userLookup;
    sysConfigService.getSystemConfig(SysFeatures.displayUserNames).then((value: string) => {
      this.showUserName =
        value == "true" || value == "TRUE" || value == "1" || value == "Y" || value == "y";
    });
  }

  retrieveData(data: any, columnProperty: string): string {
    if (this.myUserLookup) {
      let key: any = data[columnProperty];
      let userCode: boolean = typeof key === "string";
      let user: CubiqTS.UserImpl = userCode
        ? this.myUserLookup.getUser(key)
        : this.myUserLookup.getItem(key);

      if (user) {
        return this.showUserName ? user.userName : user.userCode;
      }
    }
    return EMPTY_TEXT_VALUE;
  }
}
